import React from "react";
import ReactMarkdown from "react-markdown";

const MarkdownBlock = ({ data, update, mode }) => {
  if (mode === "edit") {
    return (
      <textarea
        className="form-control"
        rows={4}
        placeholder="Write markdown..."
        value={data.text}
        onChange={(e) => update({ text: e.target.value })}
      />
    );
  }

  return data.text ? (
    <ReactMarkdown>{data.text}</ReactMarkdown>
  ) : (
    <p className="text-muted fst-italic">Empty markdown</p>
  );
};

export default MarkdownBlock;